import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQueryConfig } from '@src/lib/api'
import { AuthDTO, ChangeSettingsDTO, Profile } from '@src/types/user'

export const userApi = createApi({
  reducerPath: 'userApi',
  baseQuery: baseQueryConfig('/'),
  tagTypes: [ 'Profile' ],
  endpoints: build => ({
    getProfile: build.query<Profile, void>({
      query: () => ({ url: '/users/me' }),
      providesTags: [ 'Profile' ]
    }),
    changeProfile: build.mutation<Profile, ChangeSettingsDTO>({
      query: (body) => ({
        method: 'POST',
        url: '/users',
        body
      }),
      invalidatesTags: [ 'Profile' ],
    }),
    signIn: build.mutation<{ access_token: string }, AuthDTO>({
      query: (body) => ({
        method: 'POST',
        url: '/auth/login',
        body
      })
    }),
  })
})

export const {
  useGetProfileQuery,
  useSignInMutation,
  useChangeProfileMutation
} = userApi